function App() {
  return (
    <div style={{ marginLeft: "8px", maxWidth: "800px" }}>
      <h1>Li Consulting</h1>
      <p>
        Li Consulting is a software consulting company with experience in
        building full-stack software solutions. These solutions include
        zkSNARKs, DeFi (EVM, MoveVM, Solana), NFTs, MEV, validator operations
        and smart contract auditing.
      </p>
      <p>Inquiries: brian[at]liconsulting.xyz</p>
    </div>
  );
}

export default App;
